export default "__VITE_ASSET__CZwuWlGp__"